// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container mat-divider {
  margin-bottom: 2rem;
}
.main-container mat-divider:first-of-type {
  margin: 2rem 0;
}
.main-container h1 {
  font-size: 250%;
  text-align: center;
  color: var(--text-color);
}
.main-container h3 {
  color: var(--text-color);
}
.main-container img {
  width: 90%;
  border-radius: 5px;
  margin-bottom: 1rem;
  color: var(--text-color);
}
.main-container .title {
  text-align: center;
  font-size: 10vh;
  margin-top: 1vh;
  margin-bottom: 6vh;
}
.main-container .faculty {
  font-size: 4vh;
  text-align: center;
  font-weight: 500;
}
.main-container .border {
  border-bottom: 2px solid var(--border-color);
}
.main-container .dateTitle {
  font-size: 6vh;
  margin-bottom: 6vw;
  margin-top: 3vw;
}

@media only screen and (max-width: 959px) {
  .fxFlex-50-90sm {
    flex: 1 1 90%;
    max-width: 90%;
    box-sizing: border-box;
  }
  .fxFlex-25-90sm {
    flex: 1 1 90%;
    max-width: 90%;
    box-sizing: border-box;
    margin: 10vw;
  }
}
@media only screen and (min-width: 960px) {
  .fxFlex-25-90sm {
    flex: 1 50%;
    max-width: 50%;
    box-sizing: border-box;
    margin: 4vw;
  }
  .fxFlex-50-90sm {
    flex: 1 1 40%;
    max-width: 40%;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/lectures/lectures.component.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAEI;EACE,cAAA;AAAN;AAIE;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;AAFJ;AAKE;EACE,wBAAA;AAHJ;AAOE;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;AALJ;AAQE;EAEE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAPJ;AAWE;EAEE,cAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAcE;EACE,4CAAA;AAZJ;AAeE;EAEE,cAAA;EACA,kBAAA;EACA,eAAA;AAdJ;;AAsBA;EACE;IACI,aAAA;IACA,cAAA;IACA,sBAAA;EAnBJ;EAsBA;IACE,aAAA;IACA,cAAA;IACA,sBAAA;IACA,YAAA;EApBF;AACF;AAyBA;EACE;IACI,WAAA;IACA,cAAA;IACA,sBAAA;IACA,WAAA;EAvBJ;EA0BA;IACE,aAAA;IACA,cAAA;IACA,sBAAA;EAxBF;AACF","sourcesContent":[".main-container {\r\n  mat-divider {\r\n    margin-bottom: 2rem;\r\n\r\n    &:first-of-type {\r\n      margin: 2rem 0;\r\n    }\r\n  }\r\n\r\n  h1 {\r\n    font-size: 250%;\r\n    text-align: center;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  h3 {\r\n    color: var(--text-color);\r\n  }\r\n\r\n\r\n  img {\r\n    width: 90%;\r\n    border-radius: 5px;\r\n    margin-bottom: 1rem;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  .title{\r\n\r\n    text-align: center;\r\n    font-size: 10vh;\r\n    margin-top: 1vh;\r\n    margin-bottom: 6vh;\r\n\r\n  }\r\n\r\n  .faculty{\r\n\r\n    font-size: 4vh;\r\n    text-align: center;\r\n    font-weight: 500;\r\n\r\n  }\r\n\r\n  .border {\r\n    border-bottom: 2px solid var(--border-color);\r\n  }\r\n\r\n  .dateTitle{\r\n\r\n    font-size: 6vh;\r\n    margin-bottom: 6vw;\r\n    margin-top: 3vw;\r\n\r\n  }\r\n  \r\n}\r\n\r\n\r\n//Media query za site uredi pomali od 960px (sm i xs uredi)\r\n@media only screen and (max-width: 959px) {\r\n  .fxFlex-50-90sm {\r\n      flex: 1 1 90%;\r\n      max-width: 90%;\r\n      box-sizing: border-box;\r\n  }\r\n\r\n  .fxFlex-25-90sm{\r\n    flex: 1 1 90%;\r\n    max-width: 90%;\r\n    box-sizing: border-box;\r\n    margin: 10vw;\r\n  }\r\n\r\n}\r\n\r\n//Media query za site uredi pogolemi od 960px (md, lg i xl uredi)\r\n@media only screen and (min-width: 960px) {\r\n  .fxFlex-25-90sm {\r\n      flex: 1 50%;\r\n      max-width: 50%;\r\n      box-sizing: border-box;\r\n      margin: 4vw;\r\n  }\r\n\r\n  .fxFlex-50-90sm {\r\n    flex: 1 1 40%;\r\n    max-width: 40%;\r\n    box-sizing: border-box;\r\n}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
